export const sanityClientConfig = {
  // replace this id with the one you find in /studio/sanity.json
  projectId: 'cm613i7u',
  // make sure that the dataset name is the same as the one in /studio/sanity.json
  dataset: 'production',
  useCdn: false
}
